export default "__VITE_ASSET__BtSRn0aG__"